import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Article } from '../model/article';
import { environment } from '../../environments/environment';
import { catchError, map, Observable, of, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Master {
  private http = inject(HttpClient);

  updateMasterArticle(formData:any){
    return this.http.patch<any>(`${environment.apiUrl}/catalog/article`,formData)
    .pipe(catchError(this.errorHandle))
  }

  getOrderStatusList(){
    return this.http.get(`${environment.apiUrl}/orderStatus/list`)
    .pipe(catchError(this.errorHandle))
  }

  getOrderDetailsById(orderId:any){
    return this.http.get(`${environment.apiUrl}/order/${orderId}`)
    .pipe(catchError(this.errorHandle))
  }

  // getCountryCode(countryName:any){
  //   return this.http.get(`https://restcountries.com/v3.1/name/${countryName}?fullText=true`)
  //   // return this.http.get(`https://restcountries.com/v3.1/alpha/${countryName}`)


  // }

  getCountryCode(countryName: string) {
    const fullTextUrl = `https://restcountries.com/v3.1/name/${countryName}?fullText=true`;
    const fallbackUrl = `https://restcountries.com/v3.1/name/${countryName}`;

    return this.http.get<any[]>(fullTextUrl).pipe(
      map(res => res?.[0]?.cca2 || null),
      catchError(() =>
        this.http.get<any[]>(fallbackUrl).pipe(
          map(res => {
            // Try to find an exact match in the fallback results
            const match = res.find(
              (c: any) =>
                c.name.common.toLowerCase() === countryName.toLowerCase() ||
                c.name.official.toLowerCase() === countryName.toLowerCase()
            );
            return match?.cca2 || res?.[0]?.cca2 || null;
          }),
          catchError(() => of(null))
        )
      )
    );
  }

  letsTalkTrade(message:any){
    return this.http.get(`${environment.apiUrl}/ai/unsecure/letsTalkTrade?conversation=${message}&orgId=&mobileNumber=`)
  }

  
  letsTalkTradeSecure(message:any,orgId:any,mobilePhone:any){
    // requires credentials
    return this.http.get(`${environment.apiUrl}/ai/secure/letsTalkTrade?conversation=${message}&orgId=${orgId}&mobileNumber=${mobilePhone}`)
  }

  getTradeGPTHistory(rowNum:any,size:any){
    return this.http.get(`${environment.apiUrl}/ai/secure/history?rowNum=${rowNum}&size=${size}`)
  }

  getProductCategory(rowNum:any,size:any){
    return this.http.get(`${environment.apiUrl}/productCategory/list?rowNum=${rowNum}&size=${size}`)
    .pipe(catchError(this.errorHandle))
  }

  postProposal(proposal:any){
    return this.http.post(`${environment.apiUrl}/investment/proposal`,proposal)
    .pipe(catchError(this.errorHandle))
  }

  errorHandle(error: any) { 
    let errorMessage = "";
    if (error.error.error instanceof ErrorEvent) {
      errorMessage = error.error.error;
    } else {
      errorMessage = error.error;
    }

    return throwError(() => {
      return errorMessage;
    });
  }
}
